var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphoneIconThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9167 64.5833V43.75H33.3334V64.5833H47.9167ZM47.9167 39.5833V33.3333C47.9167 32.7808 48.1362 32.2509 48.5269 31.8602C48.9176 31.4695 49.4475 31.25 50.0001 31.25H68.7501C69.3026 31.25 69.8325 31.4695 70.2232 31.8602C70.6139 32.2509 70.8334 32.7808 70.8334 33.3333V66.6667C70.8334 67.2192 70.6139 67.7491 70.2232 68.1398C69.8325 68.5305 69.3026 68.75 68.7501 68.75H31.2501C30.6975 68.75 30.1676 68.5305 29.7769 68.1398C29.3862 67.7491 29.1667 67.2192 29.1667 66.6667V41.6667C29.1667 41.1141 29.3862 40.5842 29.7769 40.1935C30.1676 39.8028 30.6975 39.5833 31.2501 39.5833H47.9167ZM52.0834 35.4167V64.5833H66.6668V35.4167H52.0834ZM35.4167 58.3333H45.8334V62.5H35.4167V58.3333ZM54.1667 58.3333H64.5834V62.5H54.1667V58.3333ZM54.1667 52.0833H64.5834V56.25H54.1667V52.0833ZM54.1667 45.8333H64.5834V50H54.1667V45.8333ZM35.4167 52.0833H45.8334V56.25H35.4167V52.0833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneIconThree);
export default __webpack_public_path__ + "static/media/iphone-icon-three.435e85c53afaf48f8fbe9d9f5ef7ef9c.svg";
export { ForwardRef as ReactComponent };